import { memo } from 'react';

import { Text } from '../text';
import { Chip } from './chip.styles';
import { ChipProps } from './chip.types';

const ChipComponent = ({ label, startIcon, endIcon, cursor, variant = 'primary' }: ChipProps) => {
	return (
		<Chip align="center" gap={12} cursor={cursor} variant={variant}>
			{startIcon}
			<Text color="inherit" label={label} cursor={cursor} />
			{endIcon}
		</Chip>
	);
};

export default memo(ChipComponent);
